import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { GuestRefundReasonService } from '../guest-refund-reason.service';
import { GuestRefundService } from '@app/_components/guest-refund/guest-refund.service';
import { GuestRefundReason } from '../guest-refund-reason';

@Component({
    selector: 'app-guest-refund-reason',
    templateUrl: './guest-refund-reason.component.html',
    styleUrls: ['./guest-refund-reason.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class GuestRefundReasonComponent implements OnInit {
    reasonCodes: any;
    reasonCodeGroups: any;
    guestRefunds: any;
	guestRefundIdRequired = false;
    guestRefundId: any;

	constructor(
		private guestRefundService: GuestRefundService,
		private primengConfig: PrimeNGConfig,
		private guestRefundReasonService: GuestRefundReasonService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
		this.guestRefundId = data.guestRefundId,
			this.guestRefundReason = data.guestRefundReason,
			this.statuses = guestRefundReasonService.statuses;
			this.reasonCodes = guestRefundReasonService.reasonCodes;
			this.reasonCodeGroups = guestRefundReasonService.reasonCodeGroups;
	}

	@Input() guestRefundReason: GuestRefundReason;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	guestRefundReasonId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	addCompleted = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'guestRefundReasonId': [],
		'reasonCode': [
			{ type: 'required', message: 'Required' }
		],
		'reasonDesc': [
			{ type: 'required', message: 'Required' }
		],
		'refundAmount': [
			{ type: 'required', message: 'Required' }
		],
		'guestRefundId': [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole guestRefundReason object
		if (this.guestRefundReason) {
			this.guestRefundReasonId = this.guestRefundReason.guestRefundReasonId;
			this.fixDates();
			this.form1.patchValue(this.guestRefundReason);
			// Only load the guest-refund dropdown when editing — it is not rendered in add mode
			this.fetchGuestRefunds();
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.guestRefundReasonId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			if (this.formLoading) { return; }
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			
			//if(this.form1.value.guestRefundId == null && this.form1.value.guestRefundId == undefined && this.form1.value.guestRefundId == "undefined"){
				this.form1.value.guestRefundId = this.guestRefundId;
			//}
			/*if(this.form1.value.guestRefundId == null){
				this.guestRefundIdRequired = true;
				this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: "Guest refund is required" });
				return;
			}*/
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.guestRefundReasonService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestRefundReason = res.data.guestRefundReason;
						this.doAdd.emit(this.guestRefundReason);
						this.addCompleted = true;
						this.formLoading = false;
					},
					(err: any) => {
						console.log('guestRefundReason-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.formLoading = false;
					});

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('guestRefundReason: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.guestRefundReasonService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.guestRefundReason = res.data.guestRefundReason;
						this.doUpdate.emit(this.guestRefundReason);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.formLoading = true;
			this.guestRefundReasonService.delete(this.guestRefundReason.guestRefundReasonId)
				.subscribe(
					(res: any) => {
						console.log('guestRefundReason-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.guestRefundReason);
					},
					(err: any) => {
						console.log('guestRefundReason-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			guestRefundReasonId: [this.guestRefundReasonId],
			reasonCode: ['', Validators.required],
			reasonDesc: ['', Validators.required],
			refundAmount: [null, Validators.required],
			guestRefundId: [],
			});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.guestRefundReason.guestRefundReasonDate = moment(this.guestRefundReason.guestRefundReasonDate).toDate();
	}
	
	fetchGuestRefunds() {
		if (!this.guestRefunds || this.guestRefunds === undefined || this.guestRefunds.length < 1) {
			try {
				this.guestRefundService.findAll()
					.subscribe(
						res => {
							console.log('findAllActivityProvidersSummary: ' + JSON.stringify(res));
							this.guestRefunds = res.data.guestRefunds;
							return this.guestRefunds;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.guestRefunds);
		}
	}
	
	selectGuestRefund(){
		this.guestRefundIdRequired = false;
	}
}
